module.exports = __webpack_public_path__ + "img/reportInfo.396d84c2.png";